/**
 * @file Rum-init.js
 * @module rumInit
 * @description CloudWatch RUM（Real User Monitoring）の初期化と構造化ログ送信ユーティリティ
 */

import { AwsRum } from 'aws-rum-web';

let awsRumInstance;

try {
  const config = {
    sessionSampleRate: 1,
    identityPoolId: import.meta.env.VITE_RUM_IDENTITY_POOL_ID,
    endpoint: import.meta.env.VITE_RUM_ENDPOINT,
    telemetries: ["errors"],
    allowCookies: true,
    enableXRay: false,
    signing: true
  };

  const APPLICATION_ID = import.meta.env.VITE_RUM_APP_ID;
  const APPLICATION_VERSION = import.meta.env.VITE_RUM_APP_VERSION;
  const APPLICATION_REGION = import.meta.env.VITE_RUM_APP_REGION;

  awsRumInstance = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config
  );
} catch (error) {
//  console.warn('CloudWatch RUM initialization failed:', error);
}

/**
 * 構造化ログをCloudWatch RUMに送信する関数
 * @function
 * @param {string} message - ログメッセージ
 * @param {string} [code='FRONTEND_ERROR'] - エラーコードや種別
 * @param {string} [severity='ERROR'] - エラーの重大度
 * @returns {void}
 */
export function logToCloudWatch(message, code = 'FRONTEND_ERROR', severity = 'ERROR') {
  if (awsRumInstance) {
    awsRumInstance.recordError({
      name: code,
      message: `[${severity}] ${message}`
    });
//    console.warn(`[${severity}] ${message}`);
  } else {
//    console.warn('CloudWatch RUM is not initialized.');
  }
}
